import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAttackScenarios = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 36,
	height: 37,
	viewBox: "0 0 36 37",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_113259_548)",
			children: /* @__PURE__ */ _jsxs("g", {
				clipPath: "url(#clip1_113259_548)",
				children: [
					/* @__PURE__ */ _jsx("path", {
						d: "M36.0645 16.5243C36.0645 14.0606 33.5702 12.2312 28.6331 11.0848L27.9131 7.25513C27.4245 4.66953 25.5988 2.84009 23.4645 2.84009C23.1045 2.84009 22.7445 2.88887 22.3845 3.01084L19.736 3.81579C19.1702 3.98654 18.6045 4.08411 18.0131 4.08411C17.4217 4.08411 16.856 3.98654 16.2902 3.81579L13.6417 3.01084C13.2817 2.91327 12.9217 2.84009 12.5617 2.84009C10.4274 2.84009 8.60167 4.64513 8.1131 7.25513L7.3931 11.0848C2.45596 12.2312 -0.0383301 14.0606 -0.0383301 16.5243C-0.0383301 18.6952 1.89024 20.3783 5.67024 21.5492L4.8731 29.4035C4.66738 31.4281 5.79881 33.2332 7.47024 33.5259C9.42453 33.8674 12.0988 34.0381 13.6931 34.1357L14.4902 34.1845C15.4674 34.1845 16.3417 33.6966 16.9588 32.8673L17.7045 31.916C17.7045 31.916 17.9617 31.6477 18.1417 31.6477C18.3217 31.6477 18.5017 31.8184 18.5788 31.916L19.2988 32.8673C19.9674 33.721 20.8674 34.2089 21.7931 34.2089H21.9474C23.7731 34.0869 26.6017 33.843 28.556 33.5503C29.3531 33.4283 30.0731 32.9161 30.5874 32.0867C31.0502 31.3306 31.256 30.3549 31.1274 29.4279L30.3302 21.5735C34.1617 20.4271 36.116 18.744 36.116 16.5487L36.0645 16.5243ZM28.2474 30.3792C26.216 30.7207 23.0788 30.9159 21.8188 30.9891C21.716 30.9891 21.536 30.8915 21.4074 30.7207L20.6874 29.7694C20.0188 28.9157 19.1445 28.4522 18.2188 28.4522C17.2931 28.4522 16.4188 28.9157 15.7502 29.7694L14.9788 30.7451C14.876 30.9159 14.7217 30.9891 14.5674 30.9891C11.816 30.8427 9.42453 30.5988 7.98453 30.3305C7.83024 30.3061 7.62453 30.0378 7.67596 29.6719L8.42167 22.1102C11.3017 22.6956 14.876 23.0371 18.0645 23.0371C21.2531 23.0371 24.8274 22.6956 27.7074 22.1102L28.4531 29.7694C28.4531 29.9158 28.4531 30.0621 28.2217 30.3549L28.2474 30.3792ZM18.0388 19.988C8.01024 19.988 2.91881 17.3536 2.73881 16.5731C2.79024 16.3048 3.89596 15.3291 6.80167 14.4753L6.41596 16.5243L9.06453 17.2805L10.7874 7.88934C10.9931 6.76728 11.7388 5.96233 12.5874 5.96233C12.716 5.96233 12.8445 5.96233 12.9731 6.01112L15.6474 6.81607C16.4188 7.0356 17.2417 7.15756 18.0645 7.15756C18.8874 7.15756 19.7102 7.0356 20.4817 6.81607L23.1302 6.01112C23.1302 6.01112 23.3874 5.96233 23.516 5.96233C24.3645 5.96233 25.1102 6.76728 25.316 7.88934L27.0388 17.2805L29.6874 16.5243L29.276 14.4753C32.2845 15.3535 33.3131 16.3048 33.3388 16.5487C33.1588 17.3536 28.0417 19.988 18.0388 19.988Z",
						fill: "currentColor"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M12.2531 24.7201C11.0703 24.7201 10.0417 25.4275 9.42454 25.9397C9.09026 26.2324 9.09026 26.7935 9.42454 27.1106C10.0417 27.6228 11.0703 28.3302 12.2531 28.3302C13.436 28.3302 14.4645 27.6228 15.0817 27.1106C15.416 26.8178 15.416 26.208 15.0817 25.9397C14.4645 25.4275 13.436 24.7201 12.2531 24.7201Z",
						fill: "currentColor"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M23.7731 24.7201C22.5903 24.7201 21.5617 25.4275 20.9446 25.9397C20.6103 26.2324 20.6103 26.8422 20.9446 27.1106C21.5617 27.6228 22.5903 28.3302 23.7731 28.3302C24.956 28.3302 25.9846 27.6228 26.6017 27.1106C26.936 26.8178 26.936 26.2568 26.6017 25.9397C25.9846 25.4275 24.956 24.7201 23.7731 24.7201Z",
						fill: "currentColor"
					})
				]
			})
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_113259_548",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 36,
				height: 36,
				fill: "white",
				transform: "translate(0 0.5)"
			})
		}), /* @__PURE__ */ _jsx("clipPath", {
			id: "clip1_113259_548",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 36.1286,
				height: 31.32,
				fill: "white",
				transform: "translate(-0.0639648 2.84009)"
			})
		})] })
	]
});
const ForwardRef = forwardRef(SvgAttackScenarios);
export { ForwardRef as ReactComponent };
